import { render, staticRenderFns } from "./OutstandingEstimationSparepart.vue?vue&type=template&id=5564fb85&scoped=true"
import script from "./OutstandingEstimationSparepart.vue?vue&type=script&lang=js"
export * from "./OutstandingEstimationSparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564fb85",
  null
  
)

export default component.exports